import { ConfigModel } from "./models/config.model";

export const APP_THEME_DEFAULT = "default";
export const APP_THEME_SABLE = "sable";

export const SABLE_THEME_LICENSE = "webAppsThemeSable";

export const THEME_LICENSES: Partial<Record<AppThemeModel, string>> = {
  [APP_THEME_SABLE]: SABLE_THEME_LICENSE,
};

export const APP_THEMES = [APP_THEME_DEFAULT, APP_THEME_SABLE] as const;

export type AppThemeModel = (typeof APP_THEMES)[number];

/** Returns whether a backend configuration value names a supported application theme. */
export function isAppTheme(theme: unknown): theme is AppThemeModel {
  return (
    typeof theme === "string" && APP_THEMES.includes(theme as AppThemeModel)
  );
}

/** Resolves missing or unsupported configuration values to the default application theme. */
export function resolveAppTheme(theme?: string): AppThemeModel {
  return isAppTheme(theme) ? theme : APP_THEME_DEFAULT;
}
